export default __webpack_public_path__ + "055cce09c8c2e3d1269e97f5d6e7c61e.png";